import { gql } from "graphql-request";

export const READ_TASK_BY_ID = gql`
  query ReadTaskById($id: ID!) {
    readTaskById(id: $id) {
      id
      title
      description
      tenantId
      projectId
      accountableRoleId
      assignedTenantUserId
      status
      sequence
      labels
      dueDate
      deferDate
      cost
      imageUrls
      plannedDurationMin
      actualDurationMin
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_ALL_TASKS = gql`
  query ReadAllTasks(
    $tenantId: ID!
    $projectId: ID
    $assignedTenantUserId: ID
    $accountableRoleId: ID
    $unlinkedOnly: Boolean
    $includeArchived: Boolean
  ) {
    readAllTasks(
      tenantId: $tenantId
      projectId: $projectId
      assignedTenantUserId: $assignedTenantUserId
      accountableRoleId: $accountableRoleId
      unlinkedOnly: $unlinkedOnly
      includeArchived: $includeArchived
    ) {
      id
      title
      description
      tenantId
      projectId
      accountableRoleId
      assignedTenantUserId
      status
      sequence
      labels
      dueDate
      deferDate
      cost
      imageUrls
      plannedDurationMin
      actualDurationMin
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_STANDALONE_TASKS_BY_TENANT = gql`
  query ReadStandaloneTasksByTenant(
    $tenantId: ID!
    $includeArchived: Boolean
  ) {
    readAllTasks(
      tenantId: $tenantId
      unlinkedOnly: true
      includeArchived: $includeArchived
    ) {
      id
      title
      description
      tenantId

      status
      sequence
      labels

      projectId

      accountableRoleId
      accountableRole {
        id
        name
      }

      assignedTenantUserId
      assignedTenantUser {
        id
        userId
        accessRole
        user {
          id
          firstName
          lastName
          email
        }
      }

      dueDate
      deferDate
      cost
      plannedDurationMin
      actualDurationMin
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_SOP_TASK_PROGRESS = gql`
  query ReadSOPTaskProgress($tenantId: ID!, $sopId: ID!) {
    readSOPTaskProgress(
      tenantId: $tenantId
      sopId: $sopId
    ) {
      taskId
      currentTaskVersion
      lastReadVersion
      lastReadAt
      lastUnderstoodVersion
      lastUnderstoodAt
      status
    }
  }
`;



export const READ_SCHEDULED_TASKS = gql`
  query ReadScheduledTasks($tenantId: ID!, $dueFrom: DateTime, $dueTo: DateTime) {
    readAllTasks(
      tenantId: $tenantId
      status: SCHEDULED
      dueFrom: $dueFrom
      dueTo: $dueTo
      includeArchived: false
    ) {
      id
      title
      description
      status
      dueDate
      labels
      project {
        id
        title
      }
    }
  }
`;